import styled from '@emotion/styled';
import { theme } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChairOffice,
  faUser,
} from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { useTranslation } from 'react-i18next';

type CancelReservationDeskDetailsProps = {
  reservationUserName?: string | null;
  deskName: string;
  floorName?: string;
  buildingName: string;
};

export const CancelReservationDeskDetails = ({
  reservationUserName,
  deskName,
  floorName,
  buildingName,
}: CancelReservationDeskDetailsProps): JSX.Element => {
  const { t } = useTranslation('peopleProfileSidebar', {
    keyPrefix: 'bookings.cancelReservationModal',
  });
  const { token } = theme.useToken();

  return (
    <>
      {reservationUserName && (
        <DetailRow>
          <FontAwesomeIcon icon={faUser} width={16} />
          <div>{reservationUserName}</div>
        </DetailRow>
      )}
      <DetailRow>
        <FontAwesomeIcon icon={faChairOffice} width={16} />
        <DeskSectionDescription>
          <div>{deskName}</div>
          <DeskSectionLine $color={token.colorTextSecondary}>
            {floorName
              ? t('floor_and_building', { floorName, buildingName })
              : buildingName}
          </DeskSectionLine>
        </DeskSectionDescription>
      </DetailRow>
    </>
  );
};

const DetailRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

const DeskSectionDescription = styled.div`
  display: flex;
  flex-direction: column;
`;

const DeskSectionLine = styled.div<{ $color: string }>`
  font-size: 14px;
  color: ${({ $color }) => $color};
`;
